export const SET_INVESTMENT_PRODUCTS = 'SET_INVESTMENT_PRODUCTS'
export const SET_INVESTMENT_PRODUCT = 'SET_INVESTMENT_PRODUCT'
export const ADD_INVESTMENT_PRODUCT = 'ADD_INVESTMENT_PRODUCT'
export const DELETE_INVESTMENT_PRODUCT = 'DELETE_INVESTMENT_PRODUCT'



// WEBPACK FOOTER //
// ./src/common/store/Investment/types.js